import {useState, useEffect} from "react";
import { useDispatch } from "react-redux";
import AceEditor from "react-ace";
import { Modal } from "../../../molecules";
import { MODALS } from "../../../../components/organisms/AppModals/modals.constants";
import {
    MODAL_POSITION,
    MODAL_SIZE,
    ACE_EDITOR_THEMES,
  } from "../../../../../src/constants";
  import { isPlainObject } from "lodash";

const {EDIT_JSON_MODAL, VIEW_JSON_MODAL} = MODALS;
const { LG } = MODAL_SIZE;
const { CENTER } = MODAL_POSITION;
const { DARK } = ACE_EDITOR_THEMES;
const JsonModel = ({
   inputData,
   selectedModal,
   setInputData,
   setShouldShowJsonModal,
   setSelectedModal,
   handleOnSubmit
  }) => {
    const [isValidJSON, setIsValidJSON] = useState(true);
    const dispatch = useDispatch();
    useEffect(() => {
        try {
          const isvalidJson = isPlainObject(JSON.parse(inputData));
          setIsValidJSON(isvalidJson);
        } catch (e) {
          setIsValidJSON(false);
        }
      }, [inputData]);

    const handleClose = () => {
        dispatch(setSelectedModal(null));
        setShouldShowJsonModal(false);
      };

    const footer = (
        <div className="p-6 border-t border-gray-700 text-right">
          {selectedModal === EDIT_JSON_MODAL && (<button
            className="btn btn-primary-light mr-1"
            type="button"
            onClick={handleClose}
          >
            Cancel
          </button>)}
          {selectedModal === EDIT_JSON_MODAL && (<button
            className="btn btn-primary"
            type="submit"
            onClick={handleOnSubmit}
            disabled={!isValidJSON}
          >
            Submit
          </button>)}
        </div>
      );
    
    return (
        <Modal
            title='Json Modal'
            footer={footer}
            handleClose={handleClose}
            size={LG}
            position={CENTER}
          >
            <div>
              <AceEditor
                mode="json"
                theme={DARK}
                name="aceEditor"
                className="ace-editor max-w-full"
                height="430px"
                width="800px"
                defaultValue=""
                value={inputData}
                focus={true}
                onChange={setInputData}
                setOptions={{
                  showGutter: true,
                  enableBasicAutocompletion: true,
                  enableLiveAutocompletion: true,
                  fontSize: 14,
                  highlightActiveLine: true,
                  tabSize: 4,
                  useWorker: false,
                }}
              />
              {inputData && !isValidJSON && selectedModal === EDIT_JSON_MODAL && (
                <div className="absolute text-red-500">
                  Invalid JSON document
                </div>
              )}
              {selectedModal === VIEW_JSON_MODAL && (
                <div className="absolute text-red-500">
                 Field is not editable
                </div>
              )}
            </div>
          </Modal>
    );
  }
  export default JsonModel;